var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"endpoint-container"},[_c('div',[_c('span',{staticClass:"badge badge-pill mr-1 title"},[_vm._v("MQTT")])])])}]

export { render, staticRenderFns }